import { render } from "./OnlineAgreement.vue?vue&type=template&id=c8ab96ca&scoped=true&ts=true"
import script from "./OnlineAgreement.vue?vue&type=script&lang=ts"
export * from "./OnlineAgreement.vue?vue&type=script&lang=ts"

import "./OnlineAgreement.vue?vue&type=style&index=0&id=c8ab96ca&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8ab96ca"]])

export default __exports__